module.exports = __webpack_public_path__ + "img/Cognito.7bd4c8dc.png";